import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BreadcrumbTrail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeMapping = {
    '/landing-page': { label: 'Inicio', parent: null },
    '/user-dashboard': { label: 'Dashboard', parent: null },
    '/crm-lead-management': { label: 'CRM', parent: null },
    '/referral-network': { label: 'Red de Referidos', parent: null },
    '/project-portfolio': { label: 'Proyectos', parent: null },
    '/interactive-floor-plans': { label: 'Planos Interactivos', parent: '/project-portfolio' }
  };

  const buildBreadcrumbs = () => {
    const currentRoute = routeMapping?.[location?.pathname];
    if (!currentRoute) return [];

    const breadcrumbs = [{ label: currentRoute?.label, path: location?.pathname }];
    
    let parentPath = currentRoute?.parent;
    while (parentPath) {
      const parentRoute = routeMapping?.[parentPath];
      if (parentRoute) {
        breadcrumbs?.unshift({ label: parentRoute?.label, path: parentPath });
        parentPath = parentRoute?.parent;
      } else {
        break;
      }
    }

    return breadcrumbs;
  };

  const breadcrumbs = buildBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <nav 
      className="flex items-center space-x-2 py-4 text-sm font-caption"
      aria-label="Breadcrumb"
    >
      <button
        onClick={() => handleNavigate('/user-dashboard')}
        className="flex items-center text-muted-foreground hover:text-foreground transition-smooth focus-ring rounded px-2 py-1"
      >
        <Icon name="Home" size={16} />
      </button>
      {breadcrumbs?.map((crumb, index) => {
        const isLast = index === breadcrumbs?.length - 1;
        const isClickable = !isLast;

        return (
          <React.Fragment key={crumb?.path}>
            <Icon 
              name="ChevronRight" 
              size={16} 
              color="var(--color-muted-foreground)"
            />
            {isClickable ? (
              <button
                onClick={() => handleNavigate(crumb?.path)}
                className="text-muted-foreground hover:text-foreground transition-smooth focus-ring rounded px-2 py-1 touch-target"
              >
                {crumb?.label}
              </button>
            ) : (
              <span className="text-foreground font-medium px-2 py-1">
                {crumb?.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default BreadcrumbTrail;